import { useQuery } from '@tanstack/react-query';
import { useAuth0 } from '@auth0/auth0-react';
import { createApiClient } from '../client';

export const useStyles = (poNumber: string) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const apiClient = createApiClient(getAccessTokenSilently);

  const query = useQuery({
    queryKey: ['styles', poNumber],
    queryFn: () => apiClient.getPurchaseOrderStyles(poNumber),
    enabled: isAuthenticated && Boolean(poNumber)
  });

  return {
    ...query,
    stylesData: query.data,
    loading: query.isLoading,
    errors: query.error
  };
};
